import {
  AddOneSlotToLoadingQueue,
  RemoveOneSlotToLoadingQueue,
} from "../../loading/loading.store";

import Service from "../../../../api/api-service";
import { ApiUrl } from "../../../../api/api-url";
import ShowNotification from "../../../../components/react-notifications/react-notifications";
import { NotificationMessageType } from "../../../../utils/configuration";

const service = new Service();

export const QUALIFY_GET_DETAIL_OK = "QUALIFY_GET_DETAIL_OK";
export const QUALIFY_GET_DETAIL_ERR = "QUALIFY_GET_DETAIL_ERR";

export function qualifyGetDetailOk(payload) {
  return {
    type: QUALIFY_GET_DETAIL_OK,
    payload,
  };
}

export function qualifyGetDetailErr(payload) {
  return {
    type: QUALIFY_GET_DETAIL_ERR,
    payload,
  };
}

export const qualifyGetDetailService = {
  getDetail,
};

function getDetail(id) {
  return function (dispatch) {
    dispatch(AddOneSlotToLoadingQueue);
    return service
      .get(ApiUrl.QualifyGetDetail + id)
      .then((response) => {
        dispatch(qualifyGetDetailOk(response));
        dispatch(RemoveOneSlotToLoadingQueue);
      })
      .catch((error) => {
        dispatch(qualifyGetDetailErr(error));
        dispatch(RemoveOneSlotToLoadingQueue);
        ShowNotification(error.errorMessage, NotificationMessageType.Error);
      });
  };
}
